const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "edit-user",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M6,7a5,5,0,1,1,5,5A5,5,0,0,1,6,7Zm5,12.61a2,2,0,0,1,.59-1.41l4-4A6.26,6.26,0,0,0,14,14H8a6,6,0,0,0-6,6,2,2,0,0,0,2,2h6a1,1,0,0,0,1-1Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M20.31,12.29l1.4,1.4a1,1,0,0,1,0,1.4L15.1,21.71a1.05,1.05,0,0,1-.71.29H13a1,1,0,0,1-1-1V19.61a1.05,1.05,0,0,1,.29-.71l6.62-6.61A1,1,0,0,1,20.31,12.29Z",
    style: {
      fill: "rgb(44, 169, 188)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMode);
export default __webpack_public_path__ + "static/media/edit_mode.7351875bc7ce7617aee0126f075f6e5d.svg";
export { ForwardRef as ReactComponent };